import React from "react";

function TruckXl() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64.816"
      height="30.61"
      viewBox="0 0 64.816 30.61"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M646.829 53.417a4.667 4.667 0 01-8.77-1.1"
          className="cls-1"
          transform="translate(-627.699 -26.186)"
        ></path>
        <path
          d="M661.3 56.048c-.572.25-1.2 0-1.866 0a4.668 4.668 0 01-4.571-3.726"
          className="cls-1"
          transform="translate(-636.107 -26.186)"
        ></path>
        <path
          d="M706.588 53.417a4.667 4.667 0 01-8.771-1.1"
          className="cls-1"
          transform="translate(-657.596 -26.186)"
        ></path>
        <path
          d="M721.063 56.048H719.2a4.668 4.668 0 01-4.571-3.726"
          className="cls-1"
          transform="translate(-666.005 -26.186)"
        ></path>
        <path
          d="M725.629 26.153v-6.737a.933.933 0 00-.707-.905l-6.758-1.69-1.638-8.19a1.42 1.42 0 00-1.392-1.141h-8.168"
          className="cls-1"
          transform="translate(-662.173 -3.756)"
        ></path>
        <path
          d="M706.965 52.308h5.211"
          className="cls-1"
          transform="translate(-662.173 -26.179)"
        ></path>
        <path
          d="M703.23 7.489h1.87v22.4"
          className="cls-1"
          transform="translate(-660.304 -3.756)"
        ></path>
        <path
          d="M15.025 0H0"
          className="cls-1"
          transform="translate(29.768 26.129)"
        ></path>
        <path
          d="M5.132 0H0"
          className="cls-1"
          transform="translate(14.931 26.129)"
        ></path>
        <path
          d="M0 0h14.28"
          className="cls-1"
          transform="translate(30.513 22.396)"
        ></path>
        <path
          d="M737.4 44.839h3.792V47.5c0 .778-.422 1.113-1.2 1.113l-3.339-.03"
          className="cls-1"
          transform="translate(-677.026 -22.443)"
        ></path>
        <path
          d="M618.493 48.57h14.93a.932.932 0 00.7-.933v-1.866a.933.933 0 00-.933-.932h-14.931a.934.934 0 00-.933.933v1.866c0 .516.418.932 1.167.932z"
          className="cls-1"
          transform="translate(-617.326 -22.443)"
        ></path>
        <path
          d="M715.689 11.225h-4.754a.233.233 0 00-.233.233v7a.233.233 0 00.233.233h6.715a.233.233 0 00.229-.278l-1.274-6.435a.933.933 0 00-.916-.753z"
          className="cls-1"
          transform="translate(-664.043 -5.625)"
        ></path>
        <path
          d="M653.085 22.415h-5.879V.019h26.575a1.42 1.42 0 011.42 1.42v20.976h-12.413"
          className="cls-1"
          transform="translate(-632.275 -.019)"
        ></path>
        <path
          d="M621.061 22.415V1.439a1.42 1.42 0 011.42-1.42h11.644"
          className="cls-1"
          transform="translate(-619.195 -.019)"
        ></path>
        <path
          d="M728.354 45.764a5.6 5.6 0 10-11.041 0"
          className="cls-1"
          transform="translate(-667.311 -19.636)"
        ></path>
        <circle
          cx="4.666"
          cy="4.666"
          r="4.666"
          className="cls-1"
          transform="translate(50.391 20.53)"
        ></circle>
        <circle
          cx="2.8"
          cy="2.8"
          r="2.8"
          className="cls-2"
          transform="translate(52.257 22.396)"
        ></circle>
        <path
          d="M668.6 45.765a5.6 5.6 0 10-11.041 0"
          className="cls-1"
          transform="translate(-637.414 -19.636)"
        ></path>
        <circle
          cx="4.666"
          cy="4.666"
          r="4.666"
          className="cls-1"
          transform="translate(20.53 20.53)"
        ></circle>
        <circle
          cx="2.8"
          cy="2.8"
          r="2.8"
          className="cls-2"
          transform="translate(22.396 22.396)"
        ></circle>
        <path
          d="M696.694 3.754a.933.933 0 01.933.933v16.8a.933.933 0 01-.933.933.933.933 0 01-.933-.933v-16.8a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-656.567 -1.888)"
        ></path>
        <path
          d="M689.223 3.754a.933.933 0 01.933.933v16.8a.933.933 0 01-.933.933.933.933 0 01-.933-.933v-16.8a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-652.83 -1.888)"
        ></path>
        <path
          d="M681.754 3.754a.933.933 0 01.933.933v16.8a.933.933 0 01-.933.933.933.933 0 01-.933-.933v-16.8a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-649.093 -1.888)"
        ></path>
        <path
          d="M674.283 3.754a.933.933 0 01.933.933v14.93a.933.933 0 01-.933.933.934.934 0 01-.933-.933V4.687a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-645.355 -1.888)"
        ></path>
        <path
          d="M666.814 3.754a.933.933 0 01.933.933v14.93a.933.933 0 01-.933.933.933.933 0 01-.933-.933V4.687a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-641.618 -1.888)"
        ></path>
        <path
          d="M659.343 3.754a.933.933 0 01.933.933v14.93a.933.933 0 01-.933.933.934.934 0 01-.933-.933V4.687a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-637.88 -1.888)"
        ></path>
        <path
          d="M651.874 3.754a.933.933 0 01.933.933v16.8a.933.933 0 01-.933.933.933.933 0 01-.933-.933v-16.8a.933.933 0 01.933-.933z"
          className="cls-3"
          transform="translate(-634.144 -1.888)"
        ></path>
        <rect
          width="3.033"
          height="2.8"
          className="cls-1"
          rx="1.4"
          transform="translate(.7 22.863)"
        ></rect>
        <rect
          width="3.033"
          height="2.8"
          className="cls-1"
          rx="1.4"
          transform="translate(13.065 22.863)"
        ></rect>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeMiterlimit="10"
          strokeWidth="0.284"
          d="M46.658 14.932h2.333a.7.7 0 01-.7.7h-.933a.7.7 0 01-.7-.7z"
          style={{ isolation: "isolate" }}
          opacity="0.2"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeMiterlimit="10"
          strokeWidth="0.284"
          d="M46.658 14.932h2.333a.467.467 0 01-.467.467h-1.4a.467.467 0 01-.467-.467z"
        ></path>
        <path
          d="M629.465 33.634h3.735a.933.933 0 01.933.933.934.934 0 01-.933.933h-3.733a.933.933 0 01-.933-.933.933.933 0 01.931-.933z"
          className="cls-3"
          transform="translate(-622.932 -16.837)"
        ></path>
      </g>
    </svg>
  );
}

export default TruckXl;
